import { UseQueryResult, useQuery } from "react-query";
import { EntryCollection } from "contentful";
import { fetchFromContentful } from "../ContentfulClient";

export function useContentfulData<ContentType>(
  contentType: string,
  client: string,
  language: string,
  isPreview: string | null,
  additionalFilters?: Record<string, string>,
): UseQueryResult<EntryCollection<ContentType>> {
  return useQuery(
    [
      "contentful",
      {
        content_type: contentType,
        "fields.partner[in]": `all,${client}`,
        ...additionalFilters,
        limit: 1000,
        locale: language,
      },
      isPreview,
    ],
    fetchFromContentful,
    { staleTime: Infinity },
  );
}
